<template>
  <div class="lhsx">
    <img src="./0.png" width="100%" height="40%" alt="" />
    <form id="form" v-if="!showSuccess" method="post" onsubmit="return false" action="##">
      <input type="text" class="name" placeholder="请输入真实姓名"
        @input="formData.clientName=formData.clientName.replace(/[^\u4E00-\u9FA5]/g,'')" v-model="formData.clientName"
        id="inputEmail3" />
      <input type="number" class="clientMobile" placeholder="请输入手机号码" v-model="formData.clientMobile" />
      <input type="text" class="code" placeholder="请输入验证码" v-model="formData.code" />
      <button class="send" :class="{ disable: this.verifyMsg !== '获取验证码'}" @click="sendCode()">{{ verifyMsg }}</button>
      <img src="./1-4.png" width="100%" height="15px" alt="" />
      <div class="btn" @click="submit()"></div>
    </form>
    <img id="isSuccess" v-if="showSuccess" style="margin:20px 0 30px 0 ;" src="./2.png" width="100%" height="40%"
      alt="" />
    <img src="./3(1).png" width="100%" height="82%" alt="" />
    <img src="./4.png" width="100%" height="54%" style="padding: 20px 0;" alt="" />
    <div class="topdiv" v-if="!showSuccess">
      <button class="backtop" @click="backTop()"></button>
    </div>
    <img src="./5-1.png" width="100%" height="3%" alt="" />
    <!-- <img src="./5-2.png" width="100%" height="10%" style="margin: 30px 0;" alt="" /> -->
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
  </div>
</template>


<script>
  /* eslint-disable */
  import ajax from "@/common/ajax/ajax";
  import alert from "@/components/alert/alert";
  export default {
    data() {
      return {
        formData: {
          channel: "0",
          clientName: "",
          clientMobile: "",
          code: "",
        },
        showAlert: false,
        alertMessage: "",
        verifyMsg: "获取验证码",
        wait: 30,
        showSuccess: false
      };
    },
    components: { alert },
    mounted() {
    },
    methods: {
      sendCode() {
        if (this.verifyMsg !== '获取验证码') {
          this.alertMessage = '验证码请求太快请稍等'
          this.showAlert = true
          return
        }
        if (!this.formData.clientName || this.formData.clientName.length < 2) {
          this.alertMessage = "请输入真实姓名";
          this.showAlert = true;
          return;
        }

        var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        let senddata = {
          mobile: $.trim(this.formData.clientMobile),
          type: 1003,
        };

        ajax.sendCodeLhsx(senddata).then((data) => {
          let vm = this
          function time() {
            if (vm.wait === 0) {
              vm.verifyMsg = '获取验证码'
              vm.wait = 30
            } else {
              vm.verifyMsg = vm.wait + '秒后重新发送'
              vm.wait--
              setTimeout(function () {
                time()
              }, 1000)
            }
          }

          time()
          let str = data.data.resultMessage;
        }).catch((err) => {
          this.alertMessage = "获取验证码失败"
          this.showAlert = true
        })
      },
      submit: function () {
        if (!this.formData.clientName || this.formData.clientName.length < 2) {
          this.alertMessage = "请输入真实姓名";
          this.showAlert = true;
          return;
        }
        var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
        if (!reg_tel.test(this.formData.clientMobile)) {
          this.alertMessage = "请输入正确的手机号码";
          this.showAlert = true;
          return;
        }
        if (!this.formData.code) {
          this.alertMessage = "验证码不能为空";
          this.showAlert = true;
          return;
        }
        let key = "907b067cd20ff4d0e7b928b0a1029b2a";
        if (this.$route.query.proID) {
          this.$set(this.formData, 'proID', this.$route.query.proID)
        }
        this.$forceUpdate()
        let senddata = this.utils.encrypt(JSON.stringify(this.formData), key);
        ajax.loginLhsx(senddata).then((data) => {
          if (data.data.resultStatus == 0) {
            console.log(this.$route.query.JLHC)
            if (data.data.data.needBack == 1) {
              if (this.$route.query.JLHC == undefined) {
                _baq.track("form", { assets_id: "1707939236055043" })//旧版无参数
              } else if (this.$route.query.JLHC == 'Y') {
                _baq.track("form", { assets_id: "1719109506142222" })//新版有参数
              }
            }
            this.showSuccess = true
          } else {
            this.alertMessage = data.data.resultMessage
            this.showAlert = true
          }
        }).catch((err) => {
          this.alertMessage = "申请失败"
          this.showAlert = true
        })
      },
      backTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
    }
  }
</script>

<style scoped>
  .lhsx {
    background: url("./bg.png") no-repeat;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-size: 100% 100%;
    padding: 20px 0;
  }

  #form {
    text-align: center;
    position: relative;
    padding: 30px 0;
  }

  input {
    width: 80%;
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    color: #323232;
    font-size: 14px;
    margin-bottom: 25px;
    border: 1px solid #fff;
  }

  .name {
    padding-left: 40px;
    background-image: url("1-1.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .clientMobile {
    padding-left: 40px;
    background-image: url("1-2.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .code {
    padding-left: 40px;
    background-image: url("1-3.png");
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 8px 8px;
  }

  .btn {
    background: url("./1-5.png") center center no-repeat;
    width: 40%;
    height: 40px;
    background-size: 100% 100%;
    margin: 18px 0 0 30%;
  }

  .backtop {
    background: url("./1-5.png") center center no-repeat;
    width: 40%;
    height: 40px;
    background-size: 100% 100%;
    border: #fff;
  }

  .topdiv {
    text-align: center;
    padding-bottom: 15px;
  }

  .send {
    background: #ffc500;
    border: #fff;
    font-size: 14px;
    color: #fff;
    width: 115px;
    height: 30px;
    line-height: 30px;
    position: absolute;
    right: 12%;
    bottom: 42%;
  }

  .disable {
    background: #ccc;
    border: #ccc;
  }
</style>


// WEBPACK FOOTER //
// index.vue?392bb764